module.exports = __webpack_public_path__ + "static/kamran.de904c40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/kamran.jpg
// module id = 536
// module chunks = 95715928098905 264598414423048